import { Button, FlexBox, Skeleton, Text } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { useCallback } from 'react';

import { flowsApi } from 'apis/flows';
import { useAppNavigate } from 'utils/url/useAppNavigate';

import type { BusinessHoursAutomationActivity } from '../types/automationActivity';

type RoutedThroughBusinessHoursProps = {
  node: BusinessHoursAutomationActivity;
};

export function RoutedThroughBusinessHours({
  node,
}: RoutedThroughBusinessHoursProps): JSX.Element {
  const hasBusinessHoursAccess = useHasAccess('settings.business_hours');

  const navigate = useAppNavigate();

  const { isLoading, isFetching, isError, name } =
    flowsApi.useReadFlowScheduleQuery(
      {
        id: node.scheduleId,
      },
      {
        selectFromResult: ({ data, ...rest }) => {
          return {
            name: data?.name ?? '',
            ...rest,
          };
        },
      },
    );

  const handleGoToBusinessHours = useCallback(() => {
    navigate({
      path: '/settings/businesshours/:id',
      params: {
        path: {
          id: node.scheduleId,
        },
      },
    });
  }, [node.scheduleId, navigate]);

  if (isLoading || isFetching) {
    return <Skeleton height="18px" width="200px" />;
  }

  if (isError && hasBusinessHoursAccess) {
    return (
      <FlexBox margin="300 0">
        <Button variant="secondary" onClick={handleGoToBusinessHours}>
          Go to business hours
        </Button>
      </FlexBox>
    );
  }

  return (
    <Text.Paragraph>
      Business hours · {`Automation visisted business hours schedule ${name}`}{' '}
    </Text.Paragraph>
  );
}
